import './auth';
import './user';
import './session';
import './logout';
import './identity';
import './pets';
import './organizations';
import './patients';
import './autopilot';
import './cms';
import './invitation';
import './utilities';
import './constants';
import './transactions';
import './activities';
import './browser-service';
import './uploadReceiptService';
import './manageOrganizationService';
import './manageUsersService';
import './googleservices';
import './providers';
import './communication';
import './media';
import './activityTypes';
import './resource-interceptor';
import './v2';
